import { ElementRef, inject, Injectable, RendererFactory2, Renderer2 } from '@angular/core';

import { allowedTagNames } from './allowedTagNames.constant';

/**
 * @deprecated - Will be removed with the Angular 23 migration.
 * Use the [CSS Grid](https://designsystem.acc.aws.devolksbank.net/index.html?path=/docs/components-style-grid--docs)
 * in ap/style instead
 */
@Injectable()
export class ApResponsiveService {
    private readonly rendererFactory = inject(RendererFactory2);

    /**
     * @ngdoc method
     * @name ApResponsiveService#addResponsiveClasses
     * @methodOf ApResponsiveService
     *
     * @param el The element to add classes to
     * @param colSpan
     * @param attributeName The attribute name (xs/md/xl/...)
     */
    public addResponsiveClasses(el: ElementRef, colSpan: number, attributeName: string) {
        const renderer = this.rendererFactory.createRenderer(el, null);
        const tagName = el.nativeElement.tagName;

        if (!this.isTagNameAllowed(tagName)) {
            throw new Error(`
                The attribute ${attributeName}
                may not be used on element:
                < ${tagName.toLowerCase()} >.\n
                See: http://theguide.verz.local/#/?module=fc-grid&entity=${attributeName}
            `);
        }

        if (colSpan >= 0 && colSpan <= 12) {
            renderer.addClass(el.nativeElement, 'col');
            this.removePreviousAttributeClass(renderer, el, attributeName);
            renderer.addClass(el.nativeElement, `col--${attributeName}-${colSpan}`);
        }
    }

    private isTagNameAllowed(tagName: string): boolean {
        return allowedTagNames.indexOf(tagName) >= 0;
    }

    private removePreviousAttributeClass(renderer: Renderer2, elementRef: ElementRef, attributeName: string): void {
        const classes = elementRef.nativeElement.getAttribute('class').split(' ');
        const responsiveAttribute = new RegExp(`col--${attributeName}`);
        classes
            .filter((className: string) => className.match(responsiveAttribute))
            .forEach((className: string) => renderer.removeClass(elementRef.nativeElement, className));
    }
}
